var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.56,
    height: 30,
    viewBox: "0 0 28.56 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fuel_Management",
    "data-name": "Fuel Management",
    transform: "translate(-13847.446 -4814.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M2.474,30A2.358,2.358,0,0,1,0,27.777V2.222A2.356,2.356,0,0,1,2.474,0H15.81a2.357,2.357,0,0,1,2.474,2.222v12.17h4.852V24.575A2.027,2.027,0,0,0,25.169,26.3c.874,0,2.036-.189,2.036-1.827V10.932H24.5V8.467L23.084,7.193l.958-.859,4.517,4.054V24.471c0,1.906-1.267,3.043-3.39,3.043A3.321,3.321,0,0,1,21.79,24.7l-.008-.079V15.607h-3.5v12.17A2.358,2.358,0,0,1,15.81,30Zm.462-16.014h12.64V2.635H2.936Zm22.243-3.664h1.39l-1.39-1.248Zm-15.681,3a.239.239,0,0,1-.161-.063l-3.261-3.01A.235.235,0,0,1,6,10.073V9.025a.237.237,0,0,1,.237-.237H7.9A1.364,1.364,0,0,0,9.373,7.63H6.238A.237.237,0,0,1,6,7.393V6.6a.237.237,0,0,1,.237-.238H9.127a1.426,1.426,0,0,0-1.2-.538H6.238A.237.237,0,0,1,6,5.591V4.707a.237.237,0,0,1,.237-.238h5.847a.237.237,0,0,1,.237.238V5.5a.237.237,0,0,1-.237.237H10.644a2.767,2.767,0,0,1,.282.632h1.159a.237.237,0,0,1,.237.238v.79a.237.237,0,0,1-.237.237H11.042A2.707,2.707,0,0,1,8.31,10.156l2.98,2.751a.237.237,0,0,1-.16.411Z",
    transform: "translate(13847.446 4814.648)",
    fill: "#8ee123"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelManagement);
export default __webpack_public_path__ + "static/media/Fuel Management.c6fe0f691eab78345ed4cc07b40fe810.svg";
export { ForwardRef as ReactComponent };